import { render, staticRenderFns } from "./CustomPropertySlotRight.vue?vue&type=template&id=654a16d7&"
import script from "./CustomPropertySlotRight.vue?vue&type=script&lang=ts&"
export * from "./CustomPropertySlotRight.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports